import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <CardsSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
        <CommentsSection />
        <AppSection />
        <TopicsSection />
        <ContactSection />
        <FaqSection />
        <CarouselSection />
        <AboutSection />
        <MediaSection />
        <RankingSection />
      </main>

      <Footer />
    </div>
  );
}